angular.module('workflow.app')

.factory( 'StepConfigSource', () ->

  class StepConfigSource
    @GOOGLE_CUSTOM_SEARCH = 'googlecustomsearch'
    @SCARAB               = 'scarab'
    @KRAKEN               = 'kraken'

    @UNSEARCHED_HEALTHY   = 'unsearched_healthy'
    @PARTIALLY_HEALTHY    = 'partially_healthy'

    constructor: ( data ) ->
      angular.copy( data, @ )

    getName: ->
      return @name

    getDescription: ->
      return @description

    isSearchable: () ->
      switch @type
        when StepConfigSource.GOOGLE_CUSTOM_SEARCH, StepConfigSource.SCARAB
          return true
        when StepConfigSource.KRAKEN
          if isUnsearched( @full_status ) or isPartiallyHealthy( @full_status )
            return false
          return true
        else
          if isPartiallyHealthy( @full_status )
            return false
          return true

    hasLocalName: () ->
      return hasNonEmptyProperty( @, 'local_language_name' )

    getLocalName: () ->
      return @local_language_name

    hasTechnicalRestriction: () ->
      return hasNonEmptyProperty( @, 'technical_restriction' )

    getTechnicalRestriction: () ->
      return @technical_restriction

    hasUrl: () ->
      return hasNonEmptyProperty( @, 'url' )

    getUrl: () ->
      return @url

    getCountries: () ->
      return @countries

    getLanguages: () ->
      return @languages

    isUnsearched = ( status ) ->
      status is StepConfigSource.UNSEARCHED_HEALTHY

    isPartiallyHealthy = ( status ) ->
      status is StepConfigSource.PARTIALLY_HEALTHY

    hasNonEmptyProperty = ( object, property ) ->
      propertyExists = object[ property ]?
      if propertyExists
        value = object[ property ]
        return value.length > 0
      else
        return false


)
